import { DocumentTitle } from "@src/backpack-console/components/DocumentTitle";
import { Loader } from "@src/global_components";
import HubspotChatVisibilityManager from "@src/HubspotChatVisibilityManager";
import { lazy, Suspense } from "react";
import AuthDesignRefreshGate from "./AuthDesignRefreshGate";
const SignInActions = lazy(() => import("./SignInActions"));
const RefreshedSignInActions = lazy(() => import("./refresh/SignInActions"));

export default function SignIn({
  isCurrentUserError,
}: Readonly<{ isCurrentUserError: boolean }>) {
  return (
    <Suspense fallback={<Loader size={80} />}>
      <HubspotChatVisibilityManager />
      <DocumentTitle title="Login" />
      <AuthDesignRefreshGate
        refreshed={
          <RefreshedSignInActions isCurrentUserError={isCurrentUserError} />
        }
        legacy={<SignInActions isCurrentUserError={isCurrentUserError} />}
      />
    </Suspense>
  );
}
